var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternsAndColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2533_25348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 70.3333C56.5685 70.3333 70 56.9019 70 40.3333C70 23.7648 56.5685 10.3333 40 10.3333C23.4315 10.3333 10 23.7648 10 40.3333C10 56.9019 23.4315 70.3333 40 70.3333Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8994 53.6729L18.8994 16.4246H34.7037V53.6729C34.7037 58.0332 31.1619 61.5751 26.8016 61.5751C22.4413 61.5751 18.8994 58.0332 18.8994 53.6729Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1328 57.3606C28.6289 57.3606 29.0312 56.9584 29.0312 56.4622C29.0312 55.9661 28.6289 55.5638 28.1328 55.5638C27.6366 55.5638 27.2344 55.9661 27.2344 56.4622C27.2344 56.9584 27.6366 57.3606 28.1328 57.3606Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8994 24.4255H34.699",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8994 32.4218H34.699",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8994 40.4227H34.699",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8994 48.4236H34.699",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0647 48.7463L47.4033 22.4077L58.5786 33.5831L32.2401 59.9217C29.1569 63.0049 24.1479 63.0049 21.0647 59.9217C17.9815 56.8385 17.9815 51.8295 21.0647 48.7463Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9565 57.5958C27.4527 57.5958 27.8549 57.1936 27.8549 56.6974C27.8549 56.2012 27.4527 55.799 26.9565 55.799C26.4603 55.799 26.0581 56.2012 26.0581 56.6974C26.0581 57.1936 26.4603 57.5958 26.9565 57.5958Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75 28.0662L52.9259 39.2421",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0913 33.7247L47.2672 44.8959",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4375 39.3785L41.6087 50.5544",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7788 45.037L35.9547 56.2129",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4113 46.5422H64.1065V62.5347H26.4113C21.9992 62.5347 18.415 58.9505 18.415 54.5384C18.415 50.1264 21.9992 46.5422 26.4113 46.5422Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8673 57.069C27.5661 57.069 28.1326 56.5025 28.1326 55.8037C28.1326 55.1049 27.5661 54.5384 26.8673 54.5384C26.1685 54.5384 25.6021 55.1049 25.6021 55.8037C25.6021 56.5025 26.1685 57.069 26.8673 57.069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2533_25348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.333344)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternsAndColor);
export default __webpack_public_path__ + "static/media/patterns_and_color.0ec3e5c8c26269272cc5e3adcb314b90.svg";
export { ForwardRef as ReactComponent };